import React from "react";
import { Routes, Route } from "react-router-dom";

import Inicio from "./pages/Inicio";
import Buscar from "./pages/Buscar";
import Anime from "./pages/Anime";
import Capitulo from "./pages/Capitulo";
import Menu from "./components/Menu";
import Catalogo from "./pages/Catalogo";
import Pie from "./components/Pie";

import { DataProvider } from "./context/DataContext";
import Site from "./pages/Site";

function App() {
  return (
    <div className="principal">
      <DataProvider>
        <Menu></Menu>

        <Routes>
          <Route path="/buscar" element={<Buscar />} />
          <Route path="/animes" element={<Catalogo />} />
          <Route path="/:id" element={<Anime />} />
          <Route path="/:id/:cap" element={<Capitulo />} />
          <Route path="/" element={<Inicio />} />
          <Route path="*" element={<Inicio />} />
          {/* <Route path="/site" element={<Site />} /> */}
        </Routes>

        <Pie></Pie>
      </DataProvider>
    </div>
  );
}

export default App;
